webpackJsonp([100599565723906],{

/***/ 363:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Church Services | Killasser Parish","author":"Kingluddite"}},"contentfulDonations":{"title":"Donations","slug":"donations","metaDescription":"Donations to Killasser Parish Church informative page","headerBackgroundImage":{"file":{"url":"//images.ctfassets.net/6rnd0h65xc7e/50N5JmZKOcSImwsUcISQys/d3fcb8a8bbef259149c8327006e3926c/adult-black-and-white-body-of-christ.jpg"}},"sectionFourHeading":"More Information","sectionFourContent":{"childMarkdownRemark":{"html":"<p>Put donation information here (placeholder)</p>"}}}},"pathContext":{"slug":"/donations/","langKey":"en-US"}}

/***/ })

});


// WEBPACK FOOTER //
// path---donations-2b8f2036a0bbd60b1c5a.js